"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var p2s = /,?([a-z]),?/gi;
function parsePathArray(path) {
    return path.join(',').replace(p2s, '$1');
}
exports.default = parsePathArray;
//# sourceMappingURL=parse-path-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/path-util/lib/parse-path-array.js
// module id = 1064
// module chunks = 37